export const subscription = {
    reward : {
        subscription : 'โปรแกรมสมาชิก',
        whopper_gold:'วอปเปอร์ วีไอพี',
    },
    profile : {
        subscription_package : 'ค้นหาโปรแกรมสมาชิก',
        my_package : 'แพ็กเกจของฉัน',
    },
    detail : {
        detail : 'รายละเอียด',
        condition : 'เงื่อนไข',
        get_plan : 'สมัครแพ็กเกจนี้',
        expired: 'หมดอายุ : ',
        buy_subscription : 'คุณซื้อแพ็กเกจนี้ไปแล้ว',
        buy_now : 'สมัครแพ็กเกจนี้',
        renewal_package : 'ต่ออายุ',
        view_package : 'ดูแพ็กเกจ',
        cancel_package : 'ยืนยัน การยกเลิกแพ็กเกจสมัครสมาชิก',
        confirm: 'ยืนยัน',
        condition_confirm_package: 'หลังจากยืนยันแล้ว แพ็กเกจจะถูกยกเลิกในรอบบิลถัดไป',
        cancel_package_success: 'ยกเลิกแพ็กเกจสมัครสมาชิกสำเร็จ! แพ็คเกจจะถูกยกเลิกในรอบบิลถัดไป',
        cancel_subscription_package: 'ยืนยัน การยกเลิกแพ็กเกจสมัครสมาชิก',
    },
    subscription_summary : {
        title : 'ตรวจสอบรายการ',
        choose_package : 'เลือกแพ็กเกจ',
        subscription_type : 'วิธีการต่ออายุ',
        one_time : 'ครั้งเดียว',
        condition_one_time : 'ไม่สามารถยกเลิกแพ็กเก็จได้ จนกว่าแพ็กเกจจะหมดอายุ',
        recurring : 'ต่ออายุอัตโนมัติ',
        condition_recurring : 'แพ็กเกจจะต่ออายุโดยอัตโนมัติทุกๆ {0} หากไม่สามารถชำระเงินได้ ระบบจะยกเลิกแพ็กเกจโดยอัตโนมัติ',
        payment_success : 'ชำระเงินเรียบร้อย!<br>แพ็กเกจสามารถใช้ได้ทันที',
        period: {
            day: 'วัน',
            month: 'เดือน',
            year: 'ปี',
        }
    },
    buy : {
        subscription_package : 'คูปองแพ็กเกจ',
        only_for_member : 'สำหรับสมาชิกวอปเปอร์วีไอพี เท่านั้น',
        condition : 'เงื่อนไข',
        buy_now : 'ซื้อตอนนี้',
        voucher_not_available : 'คูปองไม่สามารถใช้ได้',
        saved: 'ประหยัดไปถึง',
        bath: 'บาท!',
        confirm: 'ยืนยัน',
        package: 'แพ็กเกจ',
    },
    redeem : {
        //All text on these page will mapping the same as previous page
    },
    subscription_detail : {
        btn: 'รับสิทธิพิเศษ',
    }
}